module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full",
    class: _vm.classLanceOnline
  }, [_c('div', {
    staticClass: "pregao-tela2 h-full",
    class: {
      'isLoading': _vm.isLoading
    }
  }, [_c('main', {
    staticClass: "pag-arrematante"
  }, [_c('div', {
    staticClass: "row-1 flex-betw"
  }, [_c('div', {
    staticClass: "grid-left"
  }, [_c('div', {
    staticClass: "line-1 flex-betw flex-c-align"
  }, [_c('div', {
    staticClass: "cont-vector"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Lote " + _vm._s(_vm.lote.numero))]), _vm._v(" "), _c('strong', {
    staticClass: "m-l-md",
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v(_vm._s(Number(_vm.lote.quantidadeLeiloes) + 1) + "º LEILÃO")])]), _vm._v(" "), _c('form', {
    staticClass: "flex-betw flex-c-align",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.carregaPregao($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "numLote"
    }
  }, [_vm._v("Ir p/lote:")]), _vm._v(" "), _c('div', {
    staticClass: "c-input"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24,0H0V24H24Z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.99,14h.79l.28-.27a6.51,6.51,0,1,1,.7.7l-.27.28v.79l-5,4.99L3,19Zm6,0a4.5,4.5,0,1,0-4.5-4.5A4.494,4.494,0,0,0,13.99,14Z",
      "transform": "translate(0.51)",
      "fill": "#fff"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroLote),
      expression: "numeroLote"
    }],
    attrs: {
      "id": "numLote"
    },
    domProps: {
      "value": (_vm.numeroLote)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.carregaPregao($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroLote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.carregaPregao
    }
  }, [_vm._v("Ir")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "30px",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mudaManual(-1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mudaManual(+1)
      }
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-2 show-info flex-betw flex-c-align"
  }, [_c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Lance atual")]), _vm._v(" "), _c('strong', {
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Avaliação")]), _vm._v(" "), _c('strong', {
    staticClass: "red-show"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorAvaliacao)))])]), _vm._v(" "), _c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Mínimo")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorMinimo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "line-3 show-info flex-betw flex-c-align"
  }, [_c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Fipe/Lance")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.fipeLance))])]), _vm._v(" "), _c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Fipe/Avaliação")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.porcentagemAvaliacao) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Fipe/Minímo")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.porcentagemMinimo) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-4 show-info flex-betw flex-c-align"
  }, [_c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Tabela Fipe")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorTabelaFipe)))])]), _vm._v(" "), _c('div', {
    staticClass: "item-show flex-betw flex-c-align"
  }, [_c('span', [_vm._v("Total do Leilão")]), _vm._v(" "), _c('strong', {
    staticClass: "red-show"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.stats.previsaoVendas)))])]), _vm._v(" "), _c('div', {
    staticClass: "item-show item-reset flex-betw flex-c-align"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid-right flex-betw"
  }, [_c('div', {
    staticClass: "line-extra"
  }, [_c('span', [_c('relogio')], 1), _vm._v(" "), _c('div', {
    staticClass: "cont-comitente"
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.comitente.imagemUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line-infos"
  }, [_c('div', {
    staticClass: "line-1"
  }, [_c('div', {
    staticClass: "cont-vector"
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.tituloLote))])]), _vm._v(" "), _c('div', {
    staticClass: "line-2"
  }, [_c('p', [_vm._v("Observação: "), _c('strong', [_vm._v(_vm._s(_vm.observacaoLote))])])]), _vm._v(" "), _c('div', {
    staticClass: "line-3"
  }, [_c('img', {
    ref: "loteImagem",
    attrs: {
      "src": _vm.lote.imagem
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.descricaoLote))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-2"
  }, [_c('ul', {
    staticClass: "list-thubs is-five-mobile"
  }, _vm._l((_vm.animFotos), function(foto) {
    return _c('li', [_c('a', [_c('img', {
      attrs: {
        "src": foto.image
      }
    })])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22aa977b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-tela2/Main.vue
// module id = 734
// module chunks = 2